<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import Blok from '../blok.svelte';
	import type { SbResponsiveMuxVideo } from '../types';
	import { device } from '$lib/state/device.svelte';

	interface Props {
		content: ISbStoryData<SbResponsiveMuxVideo>['content'];
	}

	let { content }: Props = $props();

	let asset = $derived(
		device.data.isDesktop
			? (content.asset_desktop?.[0] ?? content.asset_mobile?.[0])
			: content.asset_mobile?.[0]
	);
</script>

<Blok content={asset} />
